import FilterOperation from './src/filter-item-operation.vue';

FilterOperation.install = function (Vue) {
  Vue.component(FilterOperation.name, FilterOperation);
};

export default FilterOperation;
